import xss from 'xss';
import jsonQuery from 'json-query';
import { CHECKBOX_FILTERS } from './constants';

const isSearchValueValid = searchValue => searchValue && searchValue.trim() && searchValue.length > 0;

export const areRangeFiltersUsed = (rangeFiltersMinMax, rangeFilterValues) => {
	for (const [filterName, filter] of Object.entries(rangeFilterValues)) {
		if (
			filter.values[0] !== rangeFiltersMinMax[filterName].min ||
			filter.values[1] !== rangeFiltersMinMax[filterName].max
		) {
			return true;
		}
	}

	return false;
};

export const calcNumberOfUsedFilters = (checkedFilters, rangeFiltersMinMax, rangeFilterValues, searchValue) => {
	let rangeFiltersCnt = 0;
	let checkboxFiltersCnt = 0;
	let searchStr = 0;

	for (const [filterName, filter] of Object.entries(rangeFilterValues)) {
		if (
			filter.values[0] !== rangeFiltersMinMax[filterName].min ||
			filter.values[1] !== rangeFiltersMinMax[filterName].max
		) {
			rangeFiltersCnt++;
		}
	}

	for (const [, values] of Object.entries(checkedFilters)) {
		checkboxFiltersCnt += values.length;
	}

	if (isSearchValueValid(searchValue)) {
		searchStr = 1;
	}

	return rangeFiltersCnt + checkboxFiltersCnt + searchStr;
};

export const filterItems = (items, checkedFilters, rangeFilterValues, searchValue) => {
	let filterQuery = '';
	let searchQuery = '';

	if (isSearchValueValid(searchValue)) {
		searchQuery = '[*partNumber~/.*' + xss.filterXSS(searchValue.trim()) + '.*/i]';
	}

	Object.keys(checkedFilters).forEach((type, i) => {
		if (CHECKBOX_FILTERS.find(filterGroup => filterGroup.name === type).booleanFilters) {
			filterQuery += '[* ';
			checkedFilters[type].forEach(filter => {
				filterQuery += filter + '=true&';
			});
			filterQuery = filterQuery.slice(0, -1);
			filterQuery += ']';
		} else {
			filterQuery += '[* ';
			checkedFilters[type].forEach(filter => {
				filterQuery += type + '=' + filter + '|';
			});
			filterQuery = filterQuery.slice(0, -1);
			filterQuery += ']';
		}
	});

	for (const [filterName, filter] of Object.entries(rangeFilterValues)) {
		filterQuery += '[* ';
		filterQuery += filterName + '>=' + filter.values[0] + '&';
		filterQuery += filterName + '<=' + filter.values[1] + '|';
		filterQuery += filterName + '=?';
		filterQuery += ']';
	}

	const result = jsonQuery(filterQuery + searchQuery, {
		data: items,
		allowRegexp: true
	}).value;

	return result;
};

export const buildSelectItems = (filters, checkedFilters) =>
	filters.map(filter => ({
		label: filter.label,
		value: filter.name,
		disabled: filters.length < 2,
		checked: filters.length < 2
	}));
